import { render, staticRenderFns } from "./InsolvencyTaskQueue.vue?vue&type=template&id=6f92bcd9&scoped=true&"
import script from "./InsolvencyTaskQueue.vue?vue&type=script&lang=js&"
export * from "./InsolvencyTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyTaskQueue.vue?vue&type=style&index=0&id=6f92bcd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f92bcd9",
  null
  
)

export default component.exports